// extracted by mini-css-extract-plugin
export default {"welcomeText":"login-page-module_welcomeText-aJ0TJ","welcomeTextContainer":"login-page-module_welcomeTextContainer-yCuAX","error":"login-page-module_error-FaRKW"};